import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'black-courses-section',
  templateUrl: './courses-section.component.html',
  styleUrls: ['./courses-section.component.css'],
  standalone: true,
  imports: [RouterModule],
})
export class CoursesSectionComponent {}
